import CrudActionSetBase from './CrudActionSetBase'

export class TaskActionSet extends CrudActionSetBase('task'){}
export default new TaskActionSet()